"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CtrlBtn = exports.StyleBase = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var colors = _interopRequireWildcard(require("../style/colors"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var StyleBase = _styledComponents["default"].div.withConfig({
  displayName: "StyleBase",
  componentId: "sc-1g3lxjt-0"
})([""]);

exports.StyleBase = StyleBase;

var CtrlBtn = _styledComponents["default"].button.withConfig({
  displayName: "CtrlBtn",
  componentId: "sc-1g3lxjt-1"
})(["background:transparent;font-family:'Roboto',sans-serif;font-weight:500;color:", ";border:1px solid transparent;padding:6px 10px;font-size:16px;cursor:pointer;margin:0 5px;&:not(:disabled):hover{text-decoration:underline;}&.active-page{pointer-events:none;border-radius:2px;color:", ";}&[disabled]{cursor:auto;}&.pagination__prev:not(:disabled),&.pagination__next:not(:disabled){color:", ";}"], colors.textColor, colors.titleColor, colors.titleColor);

exports.CtrlBtn = CtrlBtn;